__turbopack_context__.v({
  "list": "ArticleItemModuleTypes-module-scss-module__4UbutG__list",
  "listItem": "ArticleItemModuleTypes-module-scss-module__4UbutG__listItem",
});
